export class AccountingModelModel {
  accountingModelId: number = 0;
  companyId: number = 0;
  consecutive: number = 0;
  description: string = '';
  createDate: string = '';
  userNameCreate: string = '';
  updateDate: string | null = null;
  userNameUpdate: string | null = null;
}
